/* this file added by Bearer Web Developer  */
import React, { useRef } from 'react';
import { TextFieldProps } from '@mui/material';
import styles from './BearerDateField.module.scss'; // added by Bearer Web Developer
import { useThemeMode } from '../../../states/contexts/theme'; // added by Bearer Web Developer 
type IColorStyle = "blue" | "gray" | "white" | "dark-blue"; // added by Bearer Web Developer
type BearerTextFieldProps = inputProperties & TextFieldProps & { validator?: (value: string) => string | undefined }
    & { colorStyle?: IColorStyle } & { clear?: () => void } // extended by Bearer Web Developer
    & { inputSmallStyle?: boolean } & { withoutLabel?: boolean }; // extended by Bearer Web Developer
// inputProperties interface added by Bearer Web Developer
interface inputProperties {
    label?: string
    value?: string
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void
    onClick?: () => {}
    min?: string
    max?: string
    disabled?: boolean
    placeholder?: string
    name?: string
}
const BearerDateField: React.FC<BearerTextFieldProps> = ({ validator, withoutLabel, inputSmallStyle, colorStyle, ...props }) => {
    const [touched, setTouched] = React.useState(false);
    const [error, setError] = React.useState({ value: null as null | string, helperText: '' });
    const inputRef = useRef(null);
    React.useEffect(() => {
        if (validator) { // validator && props.value changed to validator for not showing empty value errors by Bearer Web Developer
            const value = props.value as string;
            if (error.value !== value) {
                const helperText = validator(value);
                setError({ value, helperText: helperText || '' });
            }
        }
    }, [props.value, touched])

    const handleFocus = () => {
        setTouched(true);
    }
    // added by Bearer Web Developer start
    const handleBlur = () => {
        setTouched(false);
    }
    const handleCloseClear = () => {
        if (props?.clear) {
            props?.clear();
        }
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    // added by Bearer Web Developer end
    // modified by Bearer Web Developer start
    const { inputProps, label, name, placeholder, ...otherProps } = props;
    return (
        <div className={otherProps.disabled ? `${styles.disabled} ${styles.text_input}` : styles.text_input} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={`${colorStyle ? styles?.[colorStyle.replaceAll("-", "_")] : styles.blue}`}>
                {
                    !withoutLabel &&
                    <div className={styles.label}>
                        <label htmlFor={name || label?.toString()}>{label}</label>
                    </div>
                }
                <div className={`${styles.input_part} ${inputSmallStyle ? styles.input_small : ''}`}>
                    <input {...inputProps} name={name || label?.toString()} type='date' ref={inputRef}
                        id={name || label?.toString()}
                        {...otherProps as inputProperties}
                        onBlur={handleBlur} // added by Bearer Web Developer
                        onFocus={handleFocus} placeholder={placeholder} />
                    <>
                        {/* close clear button added by Bearer Web Developer  */}
                        {
                            props.value && props?.clear &&
                            <img className={styles.close_clear}
                                src={`/close-clear-${colorStyle === "gray" ? "black" : "blue"}.svg`}
                                alt="" width={24} height={24}
                                onClick={handleCloseClear}
                            />
                        }
                    </>
                    <img className={styles.vector}
                        src={(colorStyle === "dark-blue" || theme === "dark")? `/calendar-white.svg` : `/calendar-gray.svg`} alt="" width={18} height={20}
                        onClick={() => { if (inputRef) (inputRef?.current as any)?.showPicker(); }}
                    />
                </div>
                {
                    error.helperText &&
                    <div className={styles.error}>
                        <img src="/error-red.png" alt="" />
                        <div className={!colorStyle || (colorStyle && colorStyle?.includes('blue')) ? styles.error_blue : ''}>
                            {error.helperText}
                        </div>
                    </div>
                }
            </div>
        </div>
    );
    // modified by Bearer Web Developer end
}
export default BearerDateField;